<template>
  <div class="carrier-page">

    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Carrier Admin</h6> &nbsp;
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <!-- <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill>&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div> -->
      <div>
        <!-- START: LIST_CARRIERS -->
        <div class="accordion border-black-2" role="tablist">

          <!-- Name Table for Carriers Card -->
          <b-card no-body class="mb-0 border-non-radius">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <base-button block type="primary" title="Search" size="sm" class="border-non-radius text-left d-flex justify-content-between">
                  <div>Name</div>
                  <base-button @click="reloadButtonClick()" type="warning" class="vertical-dot-button">
                      <i class="fa fa-recycle"></i>
                  </base-button>
              </base-button>
        
            </b-card-header>
          </b-card>

          <b-card v-if="carrierLoading" id="lists_carrier_card">
            <b-row class="text-md-center">
              <b-col md="12">
                <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
              </b-col>
            </b-row>
          </b-card>

          <template v-else>
            <!-- START: NEW_CARRIER -->
          <b-card no-body class="mb-0 border-non-radius" id="new_carrier_card">
            <b-card-header header-tag="header" class="p-0 mb-0" role="tab">
              <base-button 
                    block 
                    v-b-toggle.accordion-2
                    type="light" 
                    size="md"
                    title="Search" 
                    v-on:click="newCarrierClick = !newCarrierClick" 
                    class="border-non-radius text-dark text-left">
                      <i class="fas  mr-1" v-bind:class="newCarrierClick ? 'fa-angle-down' : ' fa-angle-right'"></i>+
                      New Carrier
              </base-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion2" role="tabpanel">
              <b-card-body>
                <!-- GENERAL -->
                <b-row>
                  <b-col lg="6">
                    <base-button @click="reloadButtonClick()" type="primary" size="sm" class="text-white w-100 text-left">
                        General
                    </base-button>
                    <b-row class="mt-3">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">Parent</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            v-model="newCarrier.parent"
                            :options="newParentOption">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="name" class="mt-1">Display Name</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-group>
                          <b-form-input
                              size="sm"
                              v-model="newCarrier.display_name"
                              :state="displayNameState"
                              placeholder="Enter your name"
                          ></b-form-input>
                          <b-form-invalid-feedback :state="displayNameState">
                            Please enter a valid display name
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="6">
                    <base-button  type="primary" size="sm" class="text-white w-100 text-left">
                        Settings
                    </base-button>
                    <b-row class="mt-3">
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            id="sms-push"
                            name="sms-push"
                            class="ml-2"
                            v-model="newCarrier.flags.httpota"
                        >
                          SMS push for HTTP Poll
                        </b-form-checkbox>
                      </b-col>
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            id="allow-sms"
                            name="allow-sms"
                            class="ml-2"
                            v-model="newCarrier.flags.smsota"
                        >
                          Allow SMS OTA
                        </b-form-checkbox>
                      </b-col>
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            id="force-sms"
                            name="force-sms"
                            class="ml-2"
                            v-model="newCarrier.flags.force_smsota"
                        >
                          Force SMS OTA
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">Technology</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            v-model="newCarrier.technology"
                            :options="newTechnologyOption"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="isAdministrator">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">SIM Vendor</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            v-model="newCarrier.vendor"
                            :options="newVendorOption">
                        </b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- ICCID RANGES -->
                <div v-if="isAdministrator">
                  <b-card-header header-tag="header" class="p-0 mt-2" role="tab">
                    <base-button
                        block
                        v-b-toggle.accordion-4
                        v-on:click="newRangeClick = !newRangeClick"
                        type="primary" 
                        size="sm"
                        class="border-non-radius text-white text-left">
                        <i class="fas" v-bind:class="newRangeClick ? 'fa-angle-down' : ' fa-angle-right'"></i>&nbsp; ICCID Ranges
                    </base-button>
                  </b-card-header>
                  <b-collapse id="accordion-4" accordion="my-accordion4" role="tabpanel">
                      <b-card-body class="pl-0 pr-0 pt-2 pb-2">
                        <ValidateEach
                            v-for="(item, index) in iccIdCollection.item.iccids"
                            :key="index"
                            :state="item"
                            :rules="rules"
                          >
                            <template #default="{ v }">
                              <b-row class="mt-2 mb-3">
                               
                                <b-col cols="5" lg="5" class="iccid-left-input">
                                  <b-form-group>
                                    <b-form-input
                                      v-model="v.start.$model"
                                      type="text"
                                      size="sm"
                                      maxLength="19"
                                      :state="validateLeftState(v.start.$model)"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="validateLeftState(v.start.$model)">
                                      Please enter a valid ICCID &nbsp; 
                                      <b-icon icon="question-octagon" 
                                          variant="info" 
                                          class="font"
                                          v-b-popover.hover.right="'ICCID must start with 89XXX'"
                                          ></b-icon>
                                    </b-form-invalid-feedback>
                                    <div
                                      v-for="(error, errorIndex) in v.start.$errors"
                                      :key="errorIndex"
                                      class="text-danger text-sm"
                                    >
                                      {{ error.$message }}
                                    </div>
                                  </b-form-group>
                                </b-col>
                                <b-col cols="1" lg="1" class="text-center iccid-line"> - </b-col>
                                <b-col cols="5" lg="5" class="iccid-input-right pl-0 pr-0">
                                  <b-form-group>
                                    <b-form-input
                                      v-model="v.end.$model"
                                      type="text"
                                      size="sm"
                                      maxLength="19"
                                      :state="validateRightState(v.start.$model, v.end.$model)"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="validateRightState(v.start.$model, v.end.$model)">
                                        Please enter a valid ICCID &nbsp; 
                                      <b-icon icon="question-octagon" 
                                          variant="info" 
                                          class="font"
                                          v-b-popover.hover.right="'ICCID must start with 89XXX. And end ICCID Should be big than start ICCID'"
                                          ></b-icon>
                                    </b-form-invalid-feedback>
                                    <div
                                      v-for="(error, errorIndex) in v.end.$errors"
                                      :key="errorIndex"
                                      class="text-danger text-sm"
                                    >
                                      {{ error.$message }}
                                    </div>
                                </b-form-group>
                                </b-col>
                                <b-col cols="1" lg="1" class="text-center iccid-recycle">
                                  <base-button
                                      v-on:click="removeNewIccid(item)"
                                      type="danger" 
                                      class="vertical-dot-button">
                                      <b-icon icon="dash" class="font-16"></b-icon>
                                  </base-button>
                                </b-col>    
                              </b-row>
                            </template>
                        </ValidateEach>
                        <base-button
                            v-on:click="addNewRangesInNewCarrier()"
                            size="sm"
                            class="w-100 btn-light">
                              + Add new
                        </base-button>
                    </b-card-body>
                  </b-collapse>
                </div>

                <!-- FILES -->
                <b-card-header header-tag="header" class="p-0 mt-2" role="tab">
                  <base-button
                        block
                        v-b-toggle.accordion-5
                        size="sm"
                        v-on:click="newDataClick = !newDataClick"
                        type="warning" 
                        class="border-non-radius text-white text-left">
                        <i class="fas" v-bind:class="newDataClick ? 'fa-angle-down' : ' fa-angle-right'"></i>&nbsp; Files/Data
                  </base-button>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion5" role="tabpanel">
                  <b-card-body class="text-center pl-0 pr-0 pt-2 pb-2">
                    <div class="table-responsive">
                      <table class="table table-striped-dark " id="myTable">
                        <thead>
                          <th scope="col-4">
                            <span class="text-white">Display Name</span>
                          </th>
                          <th scope="col-2"><span class="text-white">EF</span></th>
                          <th scope="col-2"><span class="text-white">Default</span></th>
                          <th scope="col-2"><span class="text-white">Data</span></th>
                          <th></th>
                        </thead>
                        <tbody>
                          <tr class="text-black" v-for="(val,fileIndex) in this.newCarrier.files" :key="fileIndex">
                            <td class="pl-0 pr-0">
                              <b-form-input
                                  size="sm"
                                  v-model="val.display_name"
                                  :disabled="val.disabled === 1"
                                  :state="fileNameState(val.display_name)"
                              ></b-form-input>
                            </td>
                            <td>
                              <b-form-select
                                  size="sm"
                                  v-model="val.type"
                                  :options="efOptions"
                                  class="text-uppercase"
                                  :state="efState(val.type)"
                                  placeholder="EF"
                              ></b-form-select>
                            </td>
                            <td>
                              <b-form-checkbox
                                  size="sm"
                                  v-model="val.default"
                                  :disabled="val.disabled === 1"
                              >
                                Default
                              </b-form-checkbox>
                            </td>
                            <td class="d-flex">
                              <!-- <label v-b-tooltip.hover :for="'newFiles'+fileIndex" class="file_select" title="Upload File">
                                <b-icon icon="cloud-upload" variant="info" aria-hidden="true"></b-icon>
                              </label> -->
                              <input
                                  size="sm"
                                  :id="'newFiles'+fileIndex"
                                  :name="'newFiles'+fileIndex"
                                  class="w-0 h-0"
                                  type="file"
                                  @change="(e) => getFile(e, val)"
                              />
                            </td>
                            <td class="text-md-right pr-0 mr-0">
                              <base-button
                                    v-on:click="removeNewAddedFiles(fileIndex)"
                                    type="danger" 
                                    class="vertical-dot-button">
                                    <b-icon icon="dash" class="font-16"></b-icon>
                              </base-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> 
                    <base-button
                          v-on:click="addNewFileInNewCarrier()"
                          size="sm" 
                          class="w-100 btn-light">
                          + Add new
                    </base-button>
                  </b-card-body>
                </b-collapse>

                <b-row class="mt-2">
                  <b-col cols="9"></b-col>
                  <b-col cols="3">
                    <base-button
                          type="primary"
                          v-on:click="addCarrier_API(newCarrier, v)"
                          size="sm" 
                          class="w-100 text-center text-white">
                          Add
                    </base-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
         
          <!-- END: NEW_CARRIER -->

          <!-- START: EXISTING_CARRIERS -->
          <b-card no-body class="mb-0 border-non-radius carrier-page-exist" v-for="(carrier, index) in carriers" :key="carrier.name">
            <!-- EXISTING_CARRIERS: {{ carrier.display_name }} -->
            <b-card-header header-tag="header" class="p-0 d-flex align-items-center justify-content-between mb-0" role="tab" v-if="carrier.name !== ''">
              <b-button :disabled="!!carrier.disabled" v-b-toggle="'accordion-0'+index" block class="border-non-radius text-dark text-left d-flex justify-content-between">
                <div class="w-100"  v-on:click="carrier.dropdown = !carrier.dropdown">
                  <span v-if="!carrier.disabled" class="dynamic">
                    <i class="fas mr-1 fa-angle-down"></i>
                    <i class="fas mr-1 fa-angle-right ml-0"></i>
                  </span>
                  {{ carrier.display_name }}
                </div>

                <b-button class="vertical-dot-button" variant="primary" :id="carrier.name+'popover'">
                  <b-icon icon="three-dots-vertical" class="font-16"></b-icon>
                </b-button>
                <b-popover :target="carrier.name+'popover'" triggers="hover" placement="topleft">
                  <b-row>
                    <base-button
                          type="link"
                          v-on:click="disableCarrier_API({name:carrier.name, disable: !!carrier.disabled ? 0 : 1})">
                          {{!carrier.disabled ? "Disable" : "Enable"}}
                    </base-button>
                  </b-row>
                  <b-row v-if="carrier.can_remove">
                    <base-button
                          type="link"
                          v-on:click="deleteCarrier_API({name:carrier.name})">
                          Remove
                    </base-button>
                  </b-row>
                </b-popover>
              </b-button>
              
            </b-card-header>

            <!-- EXISTING_CARRIERS: LIST CONFIGURED -->
            <b-collapse :id="'accordion-0'+index" accordion="'my-accordion3" role="tabpanel">
              <b-card-body>

                <b-row>

                  <!-- EXISTING_CARRIERS: GENERAL -->
                  <b-col lg="6">
                    <base-button
                          type="primary"
                          size="sm" 
                          class="text-white w-100 text-left">
                          General
                    </base-button>
                    <b-row class="mt-3">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">Parent</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            v-model="carrier.parent"
                            :options="newParentOption"
                            :input="onChangeField(carrier,'parent')"
                            required
                        >
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="name" class="mt-1">Display Name</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-input
                            size="sm"
                            v-model="carrier.display_name"
                            placeholder="Enter your name"
                            class="mb-3"
                            :input="onChangeField(carrier,'display_name')"
                            :state="fileNameState(carrier.display_name)"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- EXISTING_CARRIERS: SETTINGS -->
                  <b-col lg="6">
                    <base-button
                          type="primary"
                          size="sm" 
                          class="text-white w-100 text-left ">
                          Settings
                    </base-button>
                    <b-row class="mt-3">
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            :id="'llc-sms-push'+carrier.name"
                            :name="'llc-sms-push'+carrier.name"
                            v-model="carrier.flags.httpota"
                            class="ml-2"
                            :input="onChangeField(carrier,'httpota')"
                        >
                          SMS push for HTTP Poll
                        </b-form-checkbox>
                      </b-col>
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            :id="'llc-allow-sms'+carrier.name"
                            :name="'llc-allow-sms'+carrier.name"
                            v-model="carrier.flags.smsota"
                            class="ml-2"
                            :input="onChangeField(carrier,'smsota')"
                        >
                          Allow SMS OTA
                        </b-form-checkbox>
                      </b-col>
                      <b-col lg="4">
                        <b-form-checkbox
                            size="sm"
                            :id="'llc-force-sms'+carrier.name"
                            :name="'llc-force-sms'+carrier.name"
                            v-model="carrier.flags.force_smsota"
                            class="ml-2"
                            :input="onChangeField(carrier,'force_smsota')"
                        >
                          Force SMS OTA
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">Technology</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select size="sm"
                                       v-model="carrier.technology"
                                       :options="newTechnologyOption"
                                       :input="onChangeField(carrier,'technology')"
                                       required
                        >
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2" v-if="isAdministrator">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">SIM Vendor</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select size="sm"
                                       v-model="carrier.vendor"
                                       :options="newVendorOption"
                                       :input="onChangeField(carrier,'vendor')"
                                       required
                        >
                        </b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>

                </b-row>

                <!-- EXISTING_CARRIERS: ICCID Ranges-->
                <b-card-header header-tag="header" class="p-0 mt-2" role="tab" v-if="isAdministrator">
                  <base-button
                        block
                        v-b-toggle.accordion-6
                        type="primary"
                        size="sm" 
                        class="border-non-radius text-white text-left"
                        v-on:click="llcRangeClick = !llcRangeClick"
                        >
                        <i class="fas ml-1" :class="llcRangeClick ? 'fa-angle-down' : ' fa-angle-right'"></i>ICCID Ranges
                  </base-button>
                </b-card-header>

                <!-- EXISTING_CARRIERS: FILES-->
                <b-collapse id="accordion-6" accordion="my-accordion6" role="tabpanel">
                  <b-card-body class="text-center pl-0 pr-0 pt-2 pb-2">
                    <ValidateEach
                        v-for="(item, index) in carrier.iccids"
                        :key="index"
                        :state="item"
                        :rules="rules"
                      >
                        <template #default="{ v }">
                          <b-row class="mt-2 mb-3">
                            <b-col cols="5" lg="5" class="iccid-left-input">
                              <b-form-input
                                v-model="v.start.$model"
                                type="text"
                                size="sm"
                                maxLength="19"
                                :disabled="item.removed===true"
                              ></b-form-input>
                              <div
                                v-for="(error, errorIndex) in v.start.$errors"
                                :key="errorIndex"
                                class="text-danger text-sm"
                              >
                                {{ error.$message }}
                              </div>
                            </b-col>
                            <b-col cols=1 lg="1" class="iccid-line"> - </b-col>
                            <b-col cols="5" lg="5" class="iccid-right-input">
                              <b-form-input
                                v-model="v.end.$model"
                                type="text"
                                size="sm"
                                maxLength="19"
                                :disabled="item.removed===true"
                              ></b-form-input>
                              <div
                                v-for="(error, errorIndex) in v.end.$errors"
                                :key="errorIndex"
                                class="text-danger text-sm"
                              >
                                {{ error.$message }}
                              </div>
                            </b-col>
                            <b-col cols="1" lg="1" class="iccid-recycle">
                              <base-button
                                    type="danger"
                                    class="vertical-dot-button"
                                    v-on:click="removeIccid(carrier, item)">
                                    <b-icon icon="dash" class="font-16"></b-icon>
                              </base-button>
                            </b-col>    
                          </b-row>
                        </template>
                    </ValidateEach>

                    <ValidateEach
                          v-for="(iccid, i) in iccIdCollection.exists[carrier.name]"
                          :key="i+11"
                          :state="iccid"
                          :rules="rules"
                        >
                      <template #default="{ v }" v-if="iccIdCollection.exists[carrier.name].length">
                        <b-row class="mt-2 mb-3">
                          
                          <b-col cols="5" lg="5" class="iccid-left-input text-left">
                            <b-form-group>
                              <b-form-input
                                v-model="v.start.$model"
                                type="text"
                                size="sm"
                                maxLength="19"
                                :state="validateLeftState(v.start.$model)"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="validateLeftState(v.start.$model)">
                                Please enter a valid ICCID &nbsp; 
                                <b-icon icon="question-octagon" 
                                    variant="info" 
                                    class="font"
                                    v-b-popover.hover.right="'ICCID must start with 89XXX'"
                                    ></b-icon>
                              </b-form-invalid-feedback>
                              <div
                                v-for="(error, errorIndex) in v.start.$errors"
                                :key="errorIndex"
                                class="text-danger text-sm"
                              >
                                {{ error.$message }}
                              </div>
                            </b-form-group>
                          </b-col>
                          <b-col cols=1 lg="1" class="iccid-line"> - </b-col>
                          <b-col cols="5" lg="5" class="iccid-right-input pr-0 pl-0 text-left">
                            <b-form-group>
                              <b-form-input
                                v-model="v.end.$model"
                                type="text"
                                size="sm"
                                maxLength="19"
                                :state="validateRightState(v.start.$model, v.end.$model)"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="validateRightState(v.start.$model, v.end.$model)">
                                  Please enter a valid ICCID &nbsp; 
                                <b-icon icon="question-octagon" 
                                    variant="info" 
                                    class="font"
                                    v-b-popover.hover.right="'ICCID must start with 89XXX. And end ICCID Should be big than start ICCID'"
                                    ></b-icon>
                              </b-form-invalid-feedback>
                              <div
                                v-for="(error, errorIndex) in v.end.$errors"
                                :key="errorIndex"
                                class="text-danger text-sm"
                              >
                                {{ error.$message }}
                              </div>
                          </b-form-group>
                            
                          </b-col>
                          <b-col cols="1" lg="1" class="iccid-recycle">
                            <base-button
                                  type="danger"
                                  class="vertical-dot-button"
                                  v-on:click="removeExistIccid(carrier.display_name,iccid)">
                                  <b-icon icon="dash" class="font-16"></b-icon>
                            </base-button>
                          </b-col>    
                        </b-row>
                      </template>
                    </ValidateEach>
                    
                  </b-card-body>
                  <base-button
                        type="warning"
                        size="sm" 
                        class="w-100 mt- btn-light"
                        v-on:click="addNewRange(carrier)">
                        + Add new
                  </base-button>
                </b-collapse>

                <b-card-header header-tag="header" class="p-0 mt-2 mb-0" role="tab">
                  <base-button
                      block
                      size="sm"
                      v-b-toggle.accordion-7
                      type="warning"
                      class="border-non-radius text-white text-left"
                      v-on:click="llcDataClick = !llcDataClick">
                          <i class="fas ml-1" :class="llcDataClick ? 'fa-angle-down' : ' fa-angle-right'"></i>Files/Data
                  </base-button>
                </b-card-header>
                <b-collapse id="accordion-7" accordion="my-accordion7" role="tabpanel">
                  <b-card-body class="text-center pl-0 pr-0 pt-2 pb-2">
                    <div class="responsive-table">
                      <table class="table table-striped-dark " id="myTable">
                        <thead>
                          <th scope="col-4">
                            <span class="text-white">Display Name</span>
                          </th>
                          <th scope="col-2"><span class="text-white">EF</span></th>
                          <th scope="col-2"><span class="text-white">Default</span></th>
                          <th scope="col-2"><span class="text-white">Data</span></th>
                          <th></th>
                        </thead>
                        <tbody>
                          <tr class="text-black" v-for="(val,fileIndex) in carrier.files" :key="fileIndex" :class="val.disabled===1?'trDisabled':''">
                            <td class="pl-0 pr-0">
                              <b-form-input size="sm" required 
                                  v-model="val.display_name" 
                                  placeholder="Display Name" 
                                  :disabled="val.disabled === 1"
                                  :state="fileNameState(val.display_name)"
                                  @input="val.display_name?val.changed=1:val.changed=0">
                              </b-form-input>
                            </td>
                            <td>
                              <b-form-select
                                size="sm"
                                v-model="val.type"
                                :options="efOptions"
                                placeholder="EF"
                                class="text-uppercase"
                                :state="efState(val.type)"
                                v-if="!val.efDisabled"
                              ></b-form-select>
                              <b-input v-model="val.type"
                                  size="sm"
                                  :disabled="val.efDisabled"
                                  style="minWidth: 200px"
                                  v-else
                                  class="text-uppercase"
                              ></b-input>
                            </td>
                            <td>
                              <b-form-checkbox
                                  size="sm"
                                  v-model="val.default"
                                  :disabled="val.disabled === 1"
                              ></b-form-checkbox>
                            </td>
                            <td>
                              <!-- <label v-b-tooltip.hover :for="'newFilesOne'+fileIndex" class="file_select" title="Upload File">
                                <b-icon icon="cloud-upload" variant="info" aria-hidden="true"></b-icon>
                              </label> -->
                              <b-input
                                  size="sm"
                                  :id="'newFilesOne'+fileIndex"
                                  :name="'newFilesOne'+fileIndex"
                                  class="w-0 h-0"
                                  v-model="val.data"
                                  :disabled="val.disabled === 1"
                                  v-if="val.data"
                              ></b-input>
                              <input
                                  size="sm"
                                  :id="'newFilesOne'+fileIndex"
                                  :name="'newFilesOne'+fileIndex"
                                  class="w-0 h-0"
                                  type="file"
                                  :disabled="val.disabled === 1"
                                  @change="(e) => getFile(e, val)"
                                  v-else
                              />
                            </td>
                            <td class="text-md-right pr-0 mr-0">
                              <base-button
                                  v-if="val.name === ''"
                                  type="danger"
                                  class="vertical-dot-button mr-0 pr-0"
                                  v-on:click="removeNewOnExisting(fileIndex, carrier)">
                                      <b-icon icon="dash" class="font-16"></b-icon>
                              </base-button>
                              <b-dropdown
                                v-else
                                size="lg"
                                variant="link"
                                toggle-class="text-decoration-none"
                                class="carrot-dropdown dropdown-menu-design"
                                no-caret
                                :dropup="true"
                              >
                                <template #button-content>
                                  <base-button
                                      type="primary"
                                      class="vertical-dot-button">
                                        <b-icon icon="three-dots-vertical" class="font-16"></b-icon>
                                  </base-button>
                                </template>
                                <!-- <b-dropdown-item
                                    @click="editFile(carrier,val)"
                                >Edit
                                </b-dropdown-item> -->
                                <b-dropdown-item
                                    v-if="!val.data"
                                    size="sm"
                                    @click="getInfo_API({carrier: carrier.name,name: val.name,type: val.type})">
                                  Info
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="!val.data"
                                    size="sm"
                                    @click="downloadFile_API({carrier: carrier.name,name: val.name,type: val.type,})">
                                  Download
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="val.disabled !== 1"
                                    size="sm"
                                    @click="showDisableFileModal({carrier: carrier.name,name: val.name,type: val.type,disable: 1})">
                                  Disable
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="val.disabled === 1"
                                    size="sm"
                                    @click="showDisableFileModal({carrier: carrier.name,name: val.name,type: val.type,disable: 0,})">
                                  Enable
                                </b-dropdown-item>
                              </b-dropdown>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <base-button
                        type="warning"
                        size="sm"
                        class="w-100 mt-2 btn-light"
                        v-on:click="addNewFile(carrier)">
                          + Add new
                    </base-button>
                  </b-card-body>
                </b-collapse>

                <!-- CAREXISTING_CARRIERSRIER: SAVE -->
                <b-row class="mt-2">
                  <b-col cols="9"></b-col>
                  <b-col cols="3">
                    <base-button
                        type="primary"
                        size="sm"
                        class="w-100 text-center text-white"
                        v-on:click="saveCarrier_API(carrier)">
                            Save
                    </base-button>
                  </b-col>
                </b-row>

              </b-card-body>
            </b-collapse>
          </b-card>
          <!-- END: EXISTING_CARRIERS -->
          </template>

        </div>
        <!-- END: LIST_CARRIERS -->
        <b-modal id="testInfoModal"  title="test info" size="sm" centered>
          <div class="input-group" v-if="info">
            <b-input-group>
              <template #prepend>
                <b-card-body class="pt-0 pb-0">
                  <div>
                    <Strong>API Name:</Strong>
                    <span class="ml-1">{{ fileInfo.name || {} }}</span>
                    <b-icon  
                        @click="copyToClipboard(fileInfo.name)" 
                        icon="file-earmark" 
                        variant="info"
                        class="font-16 cursor-pointer ml-2 mr-2"></b-icon>
                  </div>
                  <div>
                    <Strong>Size:</Strong>
                    <span class="ml-1">{{ fileInfo.size.toLocaleString('en') || 0 }} KiB</span>
                  </div>
                  <div>
                    <Strong>Modified:</Strong>
                    <span class="ml-1">{{ fileInfo.date.modified || {} }}</span>
                  </div>
                  <div>
                    <Strong>Disabled:</Strong>
                    <span class="ml-1">{{ fileInfo.disabled === 1 ? "Yes" : "No" }}</span>
                  </div>
                </b-card-body>
              </template>
            </b-input-group>
          </div>
          <template #modal-footer>
            <div>
              <base-button type="primary" size="sm" class="float-right ml-2" v-on:click="closeModal">
              OK
            </base-button>
            </div>
          </template>
        </b-modal>
      </div>
    </base-header>
  </div>
</template>

<script>
import { reactive } from 'vue'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import initService from "@/common/api-services/init-service";
import { validationMixin } from "vuelidate"
import { useVuelidate } from '@vuelidate/core'
import { ValidateEach } from '@vuelidate/components'
import { minLength, minValue, required } from '@vuelidate/validators'
import swal from "sweetalert2";
export default {
  components: {
    RouteBreadCrumb,
    ValidateEach,
  },
  name: "otaCarrier",
  setup () {
    const rules = {
      start: {
        required,
        minLength: minLength(19),
        number: true
      },
      end: {
        required,
        minLength: minLength(19),
        number: true,
      }
    }
    const iccIdCollection = reactive({exists: [], item: { iccids: []}});
    const v = useVuelidate()
    return { rules, iccIdCollection, v }
  },

  data() {
    return {
      mixins: [validationMixin],
      carrierLoading: false,
      dirty: [],
      carriers: null,
      localCarrier: null,
      startValue: "",
      item: {
        newIccids: [
          {
            start: "hello",
            end: "hellotwo"
          },
          {
            start: "new",
            end: "new Two"
          }
        ],
      },
      newCarrier: {
        parent: "",
        display_name: "",
        flags: {
          httpota: false,
          smsota: false,
          force_smsota: false
        },
        technology: "",
        vendor: "",
        iccids: [],
        files: [
          {
            name: "",
            changed: "0",
          }
        ],
        type: "carriers",
        method: ""
      },
      carrierToSend: {
        parent: "",
        display_name: "",
        flags: {
          httpota: false,
          smsota: false,
          force_smsota: false
        },
        technology: "",
        vendor: "",
        iccids: [
          {
            start: "",
            end: ""
          }
        ],
        files: [
          {
            display_name: "",
            name: "",
            changed: "",
            type: "",
            default: false,
            data: "",
            add: "",
            disable: false
          }
        ],
        type: "carriers",
        method: ""
      },
      showModal: false,
      showEditModal: false,
      showAddModal: false,
      showAddModalForNewCarrier: false,
      info: false,
      getNewFiles: false,
      file: {
        display_name: "",
        default: false,
        type: '',
        data: '',
        change: 0,
        add: 0,
      },
      imageData: "",
      removeIccidBtn: false,
      getRanges: false,
      disable: false,
      isNewCarrier: false,
      efOptions: null,
      disableData: null,
      files: [],
      fileInfo: null,
      newDataClick: false,
      newCarrierClick: false,
      newRangeClick: false,
      llcRangeClick: false,
      carrierFiles: [],
      llcDataClick: false,
      start: 0,
      end: 0,

      ///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.name [display_name]
      newParentOption: [{value: "none", text: "None"}],

      ///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.technology
      newTechnologyOption: [
        {value: "none", text: "None"},
        {value: "gsm", text: "GSM"},
        {value: "cdma", text: "CMDA"},
        {value: "both", text: "GSM & CDMA (unused)"},
      ],

      ///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.vendor
      //comes from https://ota.dccllc.net/ota/js/general.js
      newVendorOption: [
        {value: "none", text: "None"},
        {value: "gemalto", text: "Gemalto"},
        {value: "simulity", text: "Simulity"},
        {value: "simulitylte", text: "Simulity LTE"},
        {value: "esim", text: "ESIM"},
        {value: "unitedesim", text: "United eSIM"},
      ],
      // userInfo: []
      backupCarrier: [],

      //ACCESS ROLES
      noAccess: true,
      isReadOnly: true,
      isEditor: false,
      isAdministrator: false,
      isPortalAdmin: false,
      isOtaAdmin: false,
      selectedCarrier: ''
    };
  },

  mounted: function () {
    document.title = 'OTA - Carrier Admin';

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    if (!initService.getPortalAdminRole()) {
      this.$toast.error('NOTICE: This page is restricted to the DCC Portal Admin role.');
      return;
    } else {
      this.noAccess = false;
    }

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    //this.isReadOnly = (initService.getUserRoles().includes('OTA_READ'));
    //this.isEditor = (initService.getUserRoles().includes('OTA_READ'));
    //this.isAdministrator = (initService.getUserRoles().includes('Administrator') || initService.getUserRoles().includes('OTA_ADMIN'));
    //this.isPortalAdmin = (initService.getPortalAdminRole());
    this.isAdministrator = initService.getUserRoles().includes('Administrator');
    this.isOtaAdmin = initService.getUserRoles().includes('OTA_ADMIN');

    //write to console.
    // console.log('PAGE:', document.title)
    // console.log('isAdministrator:',this.isAdministrator);
    // console.log('isOtaAdmin:',this.isOtaAdmin);
    // console.log("GET THIS", initService.getUserRoles())

    //don't do anything unless the user has access
    if (!this.noAccess) {
      this.getCarrierList_API();
    }

  },

  computed: {
    lowRangeLength() {
      let status = true;
      this.item.newIccids.forEach((item) => {
        if(item.start) {
          const number = item.start.split("");
          status = item.start.length > 18 && number[0]+number[1] === "89"
        }
      });
      return status;
    },
    highRangeLength() {
      let status = true;
      this.item.newIccids.forEach((item) => {
        if(item.end) {
          const number = item.end.split("");
          status = item.end.length > 18 && number[0]+number[1] === "89"
        }
      });
      return status;
    },
    displayNameState() {
      return (this.newCarrier.display_name.length > 0 && !this.newCarrier.display_name.includes(' '));
    },
  },
  methods: {
    validateLeftState(item) {
      let pre = item.substr(0,2);
      if (pre === '89') {
        return true
      } else {
        return false
      }
    },

    validateRightState(leftItem, item) {
      let pre = item.substr(0,2);
      if (Number(item) > Number(leftItem) && pre === '89') {
        return true
      } else {
        return false
      }
    },

    fileNameState(name) {
      if (name !==undefined  && name.match("^[a-zA-Z0-9]")) {
        return true;
      } else {
        return false
      }
    },

    efState(type) {
      if (type !== '') {
        return true
      } else {
        return false
      }
    },
    /** API METHODS **/
    reloadButtonClick() {
      this.getCarrierList_API();
      this.resetCarrier();
    },

    async getCarrierList_API() {
      this.newParentOption = [{text: "None", value: ""}];
      this.carrierLoading = true;
      this.llcDataClick = false;
      this.llcRangeClick = false;
      this.newDataClick = false;
      this.newCarrierClick = false;
      this.newRangeClick = false;

      const data = JSON.stringify({add: 1, files: 1});
      await otaDashboardService
          .getCarriersList(data)
          .then(res => {
            if (res.data.result) {
              res.data.result.carriers.map(carrier => {
              if(carrier.parents === undefined || carrier.parents.length === 0) {
                carrier.parents = ""
              }
              if (carrier.hasOwnProperty("display_name") && carrier.display_name !== "") {
                  this.newParentOption.push({value: carrier.name, text: carrier.display_name});
                }
              });
              this.setCarrierData(res.data.result.carriers);
              this.efOptions = Object.entries(res.data.result.files).map(e => e[0]);
            }
           
            this.carrierLoading = false;
          })
          .catch(err => {
            this.carrierLoading = false;
            throw err;
          });
      this.carrierLoading = false;
    },

    addCarrier_API(data, v) {
      if(this.displayNameState && v.$invalid) {
        return false;
      } else {
        let enabled = true;
        const filters = this.iccIdCollection.item.iccids.filter((item) => item.start !== null || item.end !== null);
        console.log(data.files)
        if (data.files.length > 0) {
          data.files.map(item => {
            if(!enabled) return
            item.add = 1
            if (this.fileNameState(item.display_name) && this.efState(item.type)) {
              return true
            } else {
              enabled = false;
              return
            }
          })
        }
        if(enabled) {
            const payload = {
            parent: data.parent,
            display_name: data.display_name,
            flags: data.flags,
            technology: data.technology,
            vendor: data.vendor,
            iccids: [],
            files: data.files,
            type: "carriers",
            method: "add"
          }

          payload.iccids = filters;
          if (payload.iccids.length > 0) {
            payload.iccids.map(item => {
              if (this.validateLeftState(item.start) && this.validateRightState(item.start, item.end)) {
                this.addCarrierProcess(payload)
              } else {
                return false
              }
            })
          } else {
            this.addCarrierProcess(payload)
          }
        }
      }
    },

    addCarrierProcess(payload) {
      otaDashboardService.addCarrier(payload).then((res) => {
        if (res && res.data.status) {
          this.reloadButtonClick();
        } else {
            this.$toast.error(res.data.error_string)
          }
        }).catch((err) => {
          throw err;
        })
    },

    removeNewIccid(item) {
      this.iccIdCollection.item.iccids.pop();
      const newArr = this.iccIdCollection.item.iccids.filter(({start, end}) => start === item.start && end ===item.end);
      this.iccIdCollection = reactive({...this.iccIdCollection, item: {iccids: newArr}});
    },

    removeExistIccid(name, item) {
      this.iccIdCollection.exists[name].pop();
      const newArr = this.iccIdCollection.exists[name].filter(({index}) => index === item.index);
      this.iccIdCollection = reactive({...this.iccIdCollection, newArr});
    },

    async saveCarrier_API(data) {
      let current = [];
      let enabled = true;
      if(this.iccIdCollection.exists.hasOwnProperty(data.name)&& this.iccIdCollection.exists[data.name].length > 0){
        current = this.iccIdCollection.exists[data.name]
      }
      if (data.files.length > 0) {
          data.files.map(item => {
            if(!enabled) return
            item.add = 1
            if (this.fileNameState(item.display_name) && this.efState(item.type)) {
              return true
            } else {
              enabled = false;
              return
            }
          })
        }
      
        if (enabled) {
          const sendData = {
          parent: data.parent,
          display_name: data.display_name,
          files: data.files,
          name: data.name,
          flags: data.flags,
          phone_format: data.phone_format,
          primary_user: data.primary_user,
          technology: data.technology,
          vendor: data.vendor,
          type: "carriers",
          method: "modify",
          iccids: data.iccids
        }
        if(this.localCarrier && this.localCarrier.files.length) {
          sendData.files = this.localCarrier.files;
        }

        if(current.length > 0) {
          sendData['iccids'] = current;
        }

        if(data) {
          await otaDashboardService.saveCarrier(sendData).then((res) => {
            if (res && res.data.status) {
              this.reloadButtonClick();
              this.$toast.success('Carrier updated successfully!')
            } else {
              this.$toast.error(`${res.data.error_string}`)
            }
          }).catch((err) => {
            console.log("ERR", err)
            throw err;
          });
        } else {
            this.$toast.error(`ICCID already exists`)
          } 
        }
    },

    disableCarrier_API(data) {
      if (data.disable === 1) {
        swal.fire({
          title: `Disable carrier`,
          text: `This will disable the carrier '${data.name}' and any logins associated with it. Do you want to continue?`,
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "Ok",
          confirmButtonClass: "btn btn-danger",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn btn-info",
        }).then(result => {
          if (result.isConfirmed) {
            otaDashboardService.disableCarrier(data).then((res) => {
              if (res && res.data.status) {
                this.getCarrierList_API();
              } else {
                this.$toast.error(res.data.error_string)
              }
            }).catch((err) => {
              throw err;
            })
          }
        });
      } else {
        otaDashboardService.disableCarrier(data).then((res) => {
            if (res && res.data.status) {
              this.getCarrierList_API();
            } else {
              this.$toast.error(res.data.error_string)
            }
        })
      }
      
    },

    deleteCarrier_API(data) {
      swal.fire({
        title: `Remove carrier`,
        text: `This will remove the carrier '${data.name}' including any active tokens. This action is irreversible. Do you want to continue?`,
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-danger",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn btn-info",
      }).then(result => {
        if (result.isConfirmed) {
          otaDashboardService.removeCarrier(data).then((res) => {
            if (res && res.data.status) {
              this.getCarrierList_API();
            } else {
              this.$toast.error(res.data.error_string)
            }
          }).catch((err) => {
            throw err;
          })
        }
      });
    },

    getInfo_API(data) {
      otaDashboardService.getCarrierFileInfo(data).then(res => {
          if (res && res.data.status) {
            this.$bvModal.show('testInfoModal')
              this.disable = false;
              this.showModal = true;
              this.info = true;
              this.fileInfo = res.data.result;
          } else {
            this.$toast.error(res.data.error_string)
          }
        }).catch(err => {throw err;});
    },

    closeModal() {
      this.$bvModal.hide('testInfoModal')
    },

    downloadFile_API(data) {
      console.log(data);
      otaDashboardService.downloadCarrierFile(data).then(async (res) => {
        const url = `data:${res.data.result.filename},base64,${res.data.result.data}`;
        const element = document.createElement('a');
        element.href = url
        element.download = res.data.result.filename;
        element.click();
      }).catch((err) => {
        throw err;
      });
    },

    disableFile_API(data) {
      console.log('disableFile_API fired');
      console.log(data);

      this.showModal = false;
      if (!this.showModal) {
        otaDashboardService
            .disableCarrierFile(data)
            .then(data => {
              if (data) {
                this.getCarrierList_API();
              }
            })
            .catch(err => {
              throw err;
            });
      }
    },

    /** CARRIER **/

    editCarrier() {
      console.log('editCarrier fired');

      this.showEditModal = false;
      this.file.change = 1;
      this.file.add = 0;

      //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
      //TODO: Fix the carrierToSend values
      //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
      this.localCarrier.parents = this.carrierToSend.parent;
      this.localCarrier.technology = this.carrierToSend.technology;
      this.localCarrier.vendor = this.carrierToSend.vendor;
      //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

      this.localCarrier.files.push(this.file);
      this.localCarrier.type = "carrier";
      this.localCarrier.method = "modify";

      console.log('CARRIER_EDIT:');
      console.log(this.localCarrier);

      this.saveCarrier_API(this.localCarrier);
      this.resetCarrier();
    },

    resetCarrier() {
      console.log('resetCarrier fired');

      this.file = {
        display_name: "",
        default: false,
        type: '',
        data: ''
      };
      this.localCarrier = null;
      this.newCarrier = {
        parent: "",
        display_name: "",
        flags: {
          httpota: false,
          smsota: false,
          force_smsota: false
        },
        technology: "",
        vendor: "",
        iccids: [
          {
            start: "",
            end: ""
          }
        ],
        files: [
          {
            display_name: "",
            name: "",
            changed: "",
            type: "",
            default: false,
            data: "",
            add: ""
          }
        ],
        type: "carriers",
        method: ""
      };
      this.iccIdCollection = reactive({exists: [], item: { iccids: []}});
    },

    setCarrierData(carriers) {

      this.backupCarrier = {};
      let default_val = 'none';
      let default_parent = (carriers[0].parents[0] || "").toString();
      this.carriers = carriers.map(carrier => {
        carrier.files = this.objectToArray(carrier.files);
        carrier.dropdown = false;
        carrier.flags = carrier.flags;
        this.dirty[carrier.name] = false;

        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        //Fix the carrierToSend values
        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        //console.log('\n\ncarrier.name: ',carrier.name);

        //set vendor (as string)
        this.carrierToSend.vendor = (carrier.vendor ? carrier.vendor.toString() : default_val);
        carrier.vendor = this.carrierToSend.vendor;
        //console.log('carrier.vendor: ',carrier.vendor);

        //set parent
        this.carrierToSend.parent = ((Array.isArray(carrier.parents) && carrier.parents.length > 0) ? carrier.parents[0].toString() : default_parent);
        //carrier.parents = this.carrierToSend.parent;
        carrier.parent = (carrier.parents || [])[0] || default_parent;

        //set tech
        this.carrierToSend.technology = ((Array.isArray(carrier.technology) && carrier.technology.length > 0) ? carrier.technology[0].toString() : default_val);
        carrier.technology = this.carrierToSend.technology;
        //console.log('carrier.technology: ',carrier.technology);

        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // console.log('carrier.flags.httpota: '+carrier.flags.httpota);
        // console.log('carrier.flags.force_smsota: '+carrier.flags.force_smsota);
        // console.log('carrier.flags.smsota: '+carrier.flags.smsota);

        carrier.flags.httpota = (carrier.flags.httpota ? true : false);
        carrier.flags.force_smsota = (carrier.flags.force_smsota ? true : false);
        carrier.flags.smsota = (carrier.flags.smsota ? true : false);

        // console.log('carrier.flags.httpota: '+carrier.flags.httpota);
        // console.log('carrier.flags.force_smsota: '+carrier.flags.force_smsota);
        // console.log('carrier.flags.smsota: '+carrier.flags.smsota);

        if (carrier.iccids) {
          let iccidsTemp = [];
          for (let index = 0; index < carrier.iccids.length; index++) {
            iccidsTemp.push({
              start: carrier.iccids[index][0],
              end: carrier.iccids[index][1],
            });
          }
          carrier.iccids = [];
          carrier.iccids = iccidsTemp;
        }

        //clone object
        this.backupCarrier[carrier.name] = JSON.parse(JSON.stringify(carrier));

        //clone object
        return JSON.parse(JSON.stringify(carrier));
      });

      this.newCarrier = this.carriers[0];
    },


    /** RANGES **/
    addNewRange(carrier) {
      console.log('addNewRange fired', carrier.name);
      if(!(this.iccIdCollection.exists[`${carrier.name}`] || []).length) {
        console.log('here passed?')
        this.iccIdCollection.exists[`${carrier.name}`] = [];
      }
      if (this.iccIdCollection.item.iccids.length) {
        this.iccIdCollection.item.iccids.push({index: this.iccIdCollection.item.length, start: "", end: ""})
      } else {
        this.iccIdCollection.item.iccids.push({index:0, start: "", end: ""});
      }
      this.iccIdCollection = reactive({
        item:{iccids: []},
        exists:{[`${carrier.name}`]: [...this.iccIdCollection.exists[carrier.name], {index: this.iccIdCollection.exists[carrier.name].length, start: "", end: ""}]}
      });
      
      
      this.adding = !this.adding;
      this.isNewCarrier = !this.isNewCarrier;
      this.getNewFiles = !this.getNewFiles;
      this.getRanges = true;
      this.dirty[carrier.name] = !this.dirty[carrier.name];
    },

    addNewRangesInNewCarrier() {
      if (this.iccIdCollection.item.iccids.length) {
        this.iccIdCollection.item.iccids.push({index: this.iccIdCollection.item.iccids.length, start: "", end: ""})
      } else {
        this.iccIdCollection.item.iccids.push({index:0, start: "", end: ""});
      }
    },
    getlocalCarrier(carrier) {
      this.localCarrier = null;
      this.localCarrier = carrier;
      this.localCarrier.parents = this.carrierToSend.parent;
      this.localCarrier.technology = this.carrierToSend.technology;
      this.localCarrier.vendor = this.carrierToSend.vendor;
      this.localCarrier.type = "carrier";
      this.localCarrier.method = "modify";
    },
    removeIccid(carrier, iccid) {
      swal.fire({
        title: `Remove ICCID Range`,
        text: `Do you want to continue?`,
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        confirmButtonClass: "btn btn-danger",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn btn-info",
      }).then(result => {
        if (result.isConfirmed) {
          if (carrier) {
            this.getlocalCarrier(carrier);
            this.localCarrier.iccids = [{
            remove_start: iccid.start, remove_end: iccid.end}];
            this.saveCarrier_API(this.localCarrier);
          }
        }
      });
     
    },

    /** FILES **/

    addNewFile(carrier) {
      this.localCarrier = carrier;
      this.localCarrier.files.push({display_name: "", name: "", type: "", add: 1})
      this.getRanges = false;
      this.getNewFiles = true;
      this.selectedCarrier = carrier.display_name;
    },

    removeNewAddedFiles(index) {
      const files = [...this.newCarrier.files];
      files.splice(index, 1);
      this.newCarrier.files = files;
    },

    addNewFileInNewCarrier() {
      console.log('addNewFileInNewCarrier fired');
      this.newCarrier.files.push({display_name: "", name: "", type: ""})
      this.isNewCarrier = true;
    },

    removeNewOnExisting(index, carrier) {
      this.localCarrier = carrier
      const files = [...this.localCarrier.files];
      files.splice(index, 1);
      this.localCarrier.files = files;
    },  

    addFiles(carrier = null) {
      console.log('addFiles fired');

      console.log("CARRIER", carrier)

      if (!this.isNewCarrier) {
        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        //TODO: Fix the carrierToSend values
        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        this.localCarrier.parents = this.carrierToSend.parent;
        this.localCarrier.technology = this.carrierToSend.technology;
        this.localCarrier.vendor = this.carrierToSend.vendor;
        //* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        
        this.localCarrier.type = "carrier";
        this.localCarrier.method = "modify";

        console.log('CARRIER_EDIT[addFiles]:');
        console.log(this.localCarrier);

        this.saveCarrier_API(this.localCarrier);
        this.resetCarrier();
        this.showAddModal = false;

      } else {
        this.file.data = this.imageData;
        this.file.change = 0;
        this.file.add = 1;
        this.newCarrier.files.push(this.file);
        this.showAddModalForNewCarrier = false;
      }
    },

    getFile(e, file = null) {
      const files = document.getElementById(e.target.id).files;
      if (files.length > 0) {
        this.getBase64(files[0], file);
      }
    },

    editFile(carrier, file) {
      console.log('editFile fired');

      this.file = file;
      this.file.type = file.type;
      this.showEditModal = true;
      this.localCarrier = null;
      this.localCarrier = carrier;
    },

    setFile(file) {
      console.log('setFile fired');

      this.imageData = file;
    },

    objectToArray(data) {
      const res = [];
      for (let key in data) {
        const el = data[key];
        for (const elKey in el) {
          el[elKey].type = key;
          el[elKey].efDisabled = true;
          el[elKey].changed = 0
        }
        res.push(...el);
      }
      return res;
    },

    getBase64(data, file) {
      console.log('getBase64 fired');
      const reader = new FileReader()
      reader.readAsDataURL(data)
      reader.onload = () => {
        const inputData = reader.result;
        const replaced = (inputData.split(',')[0]);
        const data = inputData.replace(replaced + ",", "")
        if(data) {
          this.setFile(data);
          file.data = data;
          file.changed = "0";
          file.add = "1";
        }
        console.log("THIS", this.newCarrier);
      }
      reader.onerror = (e) => e
    },

    showDisableFileModal(payload) {
      if (payload.disable === 1) {
        swal.fire({
          title: `Disable file`,
          text: `This will disable the file and make it completely inaccessible for new provisions. Are you sure you want to continue?`,
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "Ok",
          confirmButtonClass: "btn btn-danger",
          cancelButtonText: "Cancel",
          cancelButtonClass: "btn btn-info",
        }).then(result => {
          if (result.isConfirmed) {
            this.rowStatus(payload)
          }
        });
      } else {
        this.rowStatus(payload)
      }
    },

    rowStatus(payload) {
      otaDashboardService.disableCarrierFile(payload).then(res => {
        if (res && res.data.status) {
          this.getCarrierList_API();
        }
      }).catch(err => {throw err;});
    },

    onChangeField(carrier, field) {
      // This event looks for changes and sets state to dirty.
      // NOTE: it can't set to clean if you change a variable back to what it was.
      let isDirty = false;
      Object.entries(carrier).forEach(entry => {
        const [key, value] = entry;
        if (String(this.backupCarrier[carrier.name][key]) !== String(value) && key !== 'iccids' && key !== 'files' && key !== 'dropdown') {
          if (String(this.backupCarrier[carrier.name][key]) === "" && String(value) === 'none') {
            //ignore the none='' values
          } else {
            isDirty = true;
            //console.log('dirty :: key: ' + key + ' val: ' + value);
          }
        } else if (key === 'iccids' && JSON.stringify(this.backupCarrier[carrier.name][key]) !== JSON.stringify(value)) {
          isDirty = true;
          //console.log('dirty :: key: ' + key + ' val: ' + value);
        } else if (key === 'files' && JSON.stringify(this.backupCarrier[carrier.name][key]) !== JSON.stringify(value)) {
          isDirty = true;
          //console.log('dirty :: key: ' + key + ' val: ' + value);
        }
        //console.log('key: ' + key + ' :: ' + JSON.stringify(this.backupCarrier[carrier.name][key]) + ' :: ' + JSON.stringify(value));
      });
      this.dirty[carrier.name] = isDirty;
      //console.log('dirty: ' + isDirty);
    },

    // Copy password
    copyToClipboard(token = "no-token"){
        var copyElement = document.createElement("textarea");
        copyElement.style.opacity = '0';
        copyElement.style.position = 'fixed';
        copyElement.textContent = token;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
        this.$toast.info(`Copied name to clipboard!`)
      },
  },
};

</script>
